import { useEffect, useState } from "react";

const DOCKED_SIDEBAR_MIN_WIDTH_PX = 768;

export function useDockedSidebar(): boolean {
  const [isDocked, setIsDocked] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia(`(min-width: ${DOCKED_SIDEBAR_MIN_WIDTH_PX}px)`).matches
      : false
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(min-width: ${DOCKED_SIDEBAR_MIN_WIDTH_PX}px)`
    );
    const onChange = () => setIsDocked(mediaQuery.matches);
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  }, []);

  return isDocked;
}
